import { render, staticRenderFns } from "./goodsOrder.vue?vue&type=template&id=3353924a&scoped=true&"
import script from "./goodsOrder.vue?vue&type=script&lang=js&"
export * from "./goodsOrder.vue?vue&type=script&lang=js&"
import style0 from "./goodsOrder.vue?vue&type=style&index=0&id=3353924a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3353924a",
  null
  
)

export default component.exports